<template>
  <div class="messagePush">
    <!--字典项中文参数 新消息设置 -->
    <topNav :title="$t('setting_title')" selfMethod="1"  @leftClick="goBack"></topNav>
    <div class="whiteBox">
      <div class="switchBox">
        <div class="swithChice">
          <!--字典项中文参数 接收预警消息 -->
          <div>房态图用大号字体</div>
          <div class="swicthBox">
            <mt-switch v-model="bigFont"
                       @change='changeSet'></mt-switch>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Switch } from "mint-ui";
export default {
  data() {
    return {
      messageList: {},
      vAndroid: false,
      bigFont: localStorage.getItem('fuckingBig') == 'yes',
    };
  },
  mounted() {
  },
  methods: {
    goBack(){
      this.$router.back()
    },
    //修改后台信息，传到后台
    changeSet() {
      // this.bigFont = !this.bigFont;
      if(this.bigFont){
        localStorage.setItem('fuckingBig', 'yes')
      } else {
        localStorage.setItem('fuckingBig', 'no')
      }
    },
  }
};
</script>

<style lang='less'>
.messagePush {
  background-color: #f7f8fa;
  .whiteBox {
    width: 100%;
    margin-top: 0.5333rem;
    height: auto;
    background-color: #fff;
    .switchBox {
      border-bottom: 1px solid #f7f8fa;
      width: 93.5%;
      height: 1.3333rem;
      margin: 0 auto;
      padding-top: 1px;
      .swithChice {
        width: 100%;
        height: auto;
        margin-top: 16px;
        div {
          float: left;
          font-size: 0.4267rem;
        }
        .swicthBox {
          float: right;
          margin-top: -0.1867rem;
        }
      }
    }
  }
  .tipBox {
    width: 93.5%;
    color: #999;
    height: 0.8rem;
    line-height: 0.8rem;
    margin: 0 auto;
    font-size: 0.37rem;
  }
}
.messagePush .mint-switch-input:checked + .mint-switch-core {
  border-color: #1faa1d;
  background-color: #1faa1d;
}
</style>



// WEBPACK FOOTER //
// settingHuanQiu.vue?ba408644